import { graphql } from 'react-relay';

import { BillWindowPaginator_query$key } from '../../../relay/__generated__/BillWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const BillWindowPaginator_query = graphql`
  fragment BillWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: BillFilter }
    order: { type: BillOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "BillWindowPaginatorRefreshQuery") {
    bills(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...BillConnectionDataTable_billConnection
    }
  }
`;

type Props = {} & Omit<FragmentWindowPaginatorProps<BillWindowPaginator_query$key>, 'fragment'>;

const BillWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={BillWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => <Pagination {...props} pages={data.bills.pages} loadPage={loadPage} />,
      })
    }
  </FragmentWindowPaginator>
);

export default BillWindowPaginator;
